import { GraphItemConstants } from './consts';

export const getGraphItemLabel = (type: string): string => {
  if (type.startsWith(GraphItemConstants.WILDCARD.value)) {
    return type.replace(
      GraphItemConstants.WILDCARD.value,
      GraphItemConstants.WILDCARD.displayLabel
    );
  }
  return type;
};
